import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading, hasAcceptedTerms } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/loginPage" replace />;
  }

  // Check if user has accepted terms (skip check for /terms route to avoid redirect loop)
  if (location.pathname !== '/terms' && !hasAcceptedTerms()) {
    return <Navigate to="/terms" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 